/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Victor Manuel Calle Londoño                                ║
║ victor.calle@est.iudigital.edu.co                          ║
╚════════════════════════════════════════════════════════════╝
*/
import React, { useState, useEffect, useRef } from "react";
import ListCarnets from "../modules/ListCarnets";
import {
  getCarnetUserPerFile,
  getTypeCarnets,
  getUserId,
  sendCards,
  updatedCardValidity,
  updatedStatusCarnet,
  sendCarnetAccumulated,
  CardAndUserCreateService,
  getDataSourceId,
} from "../services/carnetsPerFileService";
import ViewUserPerCard from "../modules/ViewUserPerCard";
import MDBadge from "components/MDBadge";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOffOutlined";
import CreditCardOffOutlinedIcon from "@mui/icons-material/CreditCardOffOutlined";
import { ValidityCarnet } from "../modules/ValidityCarnet";
import FilterController from "components/filter/controller/FilterController";
import { CarnetEditedStatus } from "../modules/CarnetEditedStatus";
import Spinner from "components/MDSpinner";
import MDAlert from "components/Alert";
import usePermission from "hooks/usePermission";
import ModalAddInvitadoAndCarnet from "../modules/ModalAddInvitadoAndCarnet";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CheckCircleTwoToneIcon from "@mui/icons-material/CheckCircleTwoTone";
import { getCardTypes } from "layouts/card_type/services/cardTypeService";
// import DownloadForOfflineOutlinedIcon from "@mui/icons-material/DownloadForOfflineOutlined";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { getFileCardById } from "layouts/user_carnet/services/userCarnet";
import { downloadFile } from "utils/fileUtils";
import { SUCCESS_MESSAGES, WARNING_MESSAGES, ERROR_MESSAGES } from "constants/messages";
import { formatMessage } from "utils/formatMessageUtils";
import { handleValidityAlerts } from "utils/handleValidityAlertsUtils";

export default function CarnetsPerFileController() {
  const [newData, setNewData] = useState({});
  const [defaultData, setDefaultData] = useState({});
  const [limitResult, setLimitResult] = useState([
    {
      id: "1",
      status: "active",
      created: "2023-10-23",
      updated_at: "2023-10-24",
      card_user_id: "22",
      card_type_id: "25",
    },
    {
      id: "2",
      status: "active",
      created: "2023-10-23",
      updated_at: "2023-10-24",
      card_user_id: "22",
      card_type_id: "25",
    },
  ]);

  const [userId, setUserId] = useState({});

  //Lógica para la tabla de listar usuarios carnetizados ---->
  const [listCarnets, setListCarnets] = useState();
  const [error, setError] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesStart, setEntriesStart] = useState(0);
  const [entriesEnd, setEntriesEnd] = useState(0);
  const [paginaSize, setPaginaSize] = useState(10);
  const [isFilter, setIsFilter] = useState(false);
  const [dataSourceId, setDataSourceId] = useState("");
  const [loading, setLoading] = useState(false);
  const filterControllerRef = useRef();
  const [isAlert, setIsAlert] = useState(false);
  const [typeAlert, setTypeAlert] = useState("");
  const [message, setMessage] = useState("");
  const [carnetTypes, setCarnetTypes] = useState([]);
  const [dataSource, setDataSource] = useState({ name: "", type: "" });
  const dataTable = "cards"; //Tabla indicada
  const dataFilter = useState([
    {
      field: "NOMBRE O APELLIDO",
      value: "name",
    },
    {
      field: "DOCUMENTO IDENTIFICACIÓN",
      value: "number_id",
    },
    {
      field: "CORREO ELECTRÓNICO",
      value: "email",
    },
    {
      field: "TIPO DE CARNET",
      value: "type_carnet",
    },
    {
      field: "FECHA CREACIÓN",
      value: "created",
    },
    {
      field: "FECHA VIGENCIA",
      value: "expires_in",
    },
    {
      field: "ESTADO",
      value: "status",
    },
    {
      field: "INGRESO",
      value: "joined",
    },
    {
      field: "ESTADO DE NOTIFICACIÓN",
      value: "notified",
    },
    {
      field: "ESTADO DE DESCARGA",
      value: "latest_link_status",
    },
    {
      field: "FECHA NOTIFICACIÓN",
      value: "latest_link_created_at",
    },
  ]);

  //Esperar respuesta de la función getCarnetUserPerFile y validar respuesta para actualizar la tabla de listado de carnets o mostrar error
  const requestCarnetsPerFile = async (id, pageIndex) => {
    try {
      const result = await getCarnetUserPerFile(id, pageIndex);
      if (result.status !== false) {
        const { data, last_page, total, from, to } = result;
        await setListCarnets(data);
        //await setListCarnets2(data);
        await setTotalPages(last_page);
        if (last_page <= pageIndex) {
          await setCurrentPage(last_page);
        }
        await setTotalData(total);
        await setEntriesStart(from);
        await setEntriesEnd(to);
        setError("");
      } else {
        setError("Error al consultar al servidor");
      }
    } catch (error) {
      setError("Error al consultar al servidor");
    }
  };

  const requestDownloadCardById = async (id) => {
    setLoading(true);
    try {
      const result = await getFileCardById(id);
      if (result.status !== false) {
        // Descarga el archivo pkpass utilizando la función de utilidad downloadFile.
        downloadFile(
          result.file,
          "Carnet Digital.pkpass",
          result.contentDisposition,
          (message) => handleAlert("success", message),
          (error) => handleAlert("fail", error),
          SUCCESS_MESSAGES.DOWNLOAD_COMPLETE_CARD,
          ERROR_MESSAGES.DOWNLOAD_FAILED_CARD
        );
      } else {
        handleAlert("fail", result.message || "No se pudo descargar el carnet");
      }
    } catch (e) {
      handleAlert("fail", error.message || "Fallo al descargar el carnet");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadCardById = (e) => {
    e.preventDefault();
    const {
      dataset: { id },
    } = e.currentTarget;
    if (!id) {
      handleAlert("fail", "No se encontro el identificador del carnet");
      return;
    }
    requestDownloadCardById(id);
  };

  //Cambia el valor de currentPage a la página elegida
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  //Enviar correos
  const handleSendCard = async (value) => {
    try {
      const response = await sendCards(dataSourceId, value);
      return response;
    } catch (error) {
      return {
        status: false,
        message: error.message || "Error en la operación",
      };
    }
  };

  //Lógica para el modal de vista ---->
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [viewData, setViewData] = useState({});
  const [typeCarnets, setTypeCarnets] = useState([]);

  // //Esperar respuesta de la función getTypeCarnets y validar respuesta para setear los datos retornados
  const requestTypeCarnets = async () => {
    try {
      const result = await getTypeCarnets();
      const { data } = result;
      setTypeCarnets(data);
    } catch (error) {}
  };

  //abre modal de ver detalles de carnet y setea los valores extra de dicho carnet para visualización
  const handleOpenToModal = async (event) => {
    event.preventDefault();
    resetFieldValid();
    const { dataset } = event.currentTarget;
    // await requestTypeCarnets();
    const data = {
      status: dataset.status,
      created: dataset.created,
      expired: dataset.expired,
      name_user: dataset.name,
      last_name_user: dataset.lastname,
      number_id_user: dataset.dni,
      email_user: dataset.email,
      type_card: dataset.type,
      data_source: dataset.datasource,
      blood_type: dataset.bloodtype,
      card_type_id: dataset.cardtypeid,
      custom_data: dataset.customdata || null,
      special_condition: dataset.specialcondition,
      origin_place: dataset.originplace,
    };
    setViewData(data);
    setIsOpenModal(true);
  };

  //cierra modal de ver detalles del carnet
  const handleCloseToModal = (event) => {
    event.preventDefault();
    setIsOpenModal(false);
  };
  //Obtener valor por clave especifica del objeto
  const getFieldValue = (fieldName) => {
    return viewData[fieldName];
  };

  //Obtener valor por clave especifica del objeto
  const getFieldValueAddInvitadoAndCarnet = (fieldName) => {
    return AddInvitadoAndCarnet[fieldName];
  };
  // <-------data_source_id

  function convertValuesToString(objeto) {
    const convertedObject = {};

    for (const clave in objeto) {
      if (objeto.hasOwnProperty(clave)) {
        convertedObject[clave] = String(objeto[clave]);
      }
    }

    return convertedObject;
  }
  // <-------

  //Lógica para editar ---->

  // <-------

  //Lógica para eliminar ---->

  // <-------

  //Calcula cuantas filas debe mostrarse de la página especifica y ejecuta funcion searchValidation con la pagina y filas determinadas
  const pageIndexAndPageSize = async (pageSize) => {
    await setPaginaSize(pageSize);
    await setEntriesStart(currentPage === 1 ? currentPage : (currentPage - 1) * pageSize + 1);
    //await requestCarnets(currentPage, pageSize);
    // searchValidation(currentPage, pageSize);
  };
  /*
  const requestUserPerId = async (idUser) => {
    try {
      const user = await getUserId(idUser);
      const { id, name, lastname, number_id, email, created_at } = user;
      await setUserId({
        id: id,
        name: name,
        lastname: lastname,
        number_id: number_id,
        email: email,
        created: created_at,
      });
      return { id, name, lastname, number_id, email, created_at };
    } catch (error) {
    }
  };
  */

  // cambio de vigencia de carnets --------->

  const [selected, setSelected] = useState([]);
  const [editedDataValidity, setEditedDataValidity] = useState({});
  const [AddInvitadoAndCarnet, setAddInvitadoAndCarnet] = useState({});
  const [openValidity, setOpenValidity] = useState(false);
  const [openModalAddInvitadoAndCarnet, setOpenModalAddInvitadoAndCarnet] = useState(false);
  const [isFormModified, setIsFormModified] = useState(false);

  //Esperar respuesta de la función updatedCardValidity y validar respuesta para actualizar tabla o mostrar error
  const requestUpdateValidityCard = async (editValidityCard) => {
    try {
      const result = await updatedCardValidity(editValidityCard);

      if (result.status !== false) {
        const [numInvalidCards, numCardsNotFound] = result.payload;
        // Llamar a la función reutilizable
        handleValidityAlerts(numInvalidCards, numCardsNotFound, handleAlert);
        callHandleClickSubmit();
      } else {
        handleAlert("fail", result.message || "Error al realizar la operación");
        setError("Error al consultar al servidor");
      }
    } catch (error) {
      handleAlert("fail", error.message || "Error al realizar la operación");
      setError("Error al consultar al servidor");
    }
  };

  //cerrar modal de cambio de vigencia de carnets
  const handleCloseEditValidity = () => setOpenValidity(false);

  const handleCloseAddInvitadoAndCarnet = () => {
    setAddInvitadoAndCarnet({
      name: "",
      lastname: "",
      number_id: "",
      blood_type: "",
      status: "",
      created: "",
      expires_in: "",
      card_type_id: "",
      email: "",
      photo: "",
      special_condition: "",
      origin_place: "",
    });
    setOpenModalAddInvitadoAndCarnet(false);
  };

  //Obtener valor por clave especifica del objeto
  const getFieldValueEditValidity = (fieldName) => {
    return editedDataValidity[fieldName];
  };

  //Cambiar valor por clave y valor especifico del objeto
  const handleFieldChangeEditValidity = (fieldName, value) => {
    try {
      const date = new Date(value);

      const currentDate = new Date();

      if (date < currentDate) {
        handleAlert("warning", "La fecha debe ser mayor o igual a la fecha actual.");
        return;
      }

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // Formatear como YYYY-MM-DD HH:MM:SS
      const expires_in = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      setEditedDataValidity({
        ...editedDataValidity,
        [fieldName]: expires_in,
      });
    } catch (error) {
      handleAlert("fail", "Error al procesar la fecha ingresada");
    }
  };

  //Cambiar valor por clave y valor especifico del objeto
  const handleFieldChange = (fieldName, value) => {
    setEditedDataValidity({
      ...editedDataValidity,
      [fieldName]: value,
    });
  };

  // Estado para almacenar mensajes de error
  const [fieldErrors, setFieldErrors] = useState({
    created: "",
    expires_in: "",
  });

  const handleFieldChangeAddInvitadoAndCarnet = (fieldName, value) => {
    // Obtener la hora actual en UTC -5 (Hora de Colombia)
    const now = new Date();
    now.setHours(now.getHours()); // Ajustar la hora a la zona horaria de Colombia (UTC -5)

    const selectedDate = new Date(value);

    let correctedValue = value;
    let errorMessage = "";

    if (fieldName === "created") {
      // Si la fecha seleccionada es menor que la fecha actual
      if (selectedDate < now) {
        errorMessage = "Debe ser mayor a la fecha y hora actual.";
        correctedValue = now.toISOString().slice(0, 16); // Ajustar automáticamente a la hora de Colombia
      }
    }

    if (fieldName === "expires_in") {
      // Suponiendo que `AddInvitadoAndCarnet.created` tiene la fecha de creación
      const createdDate = new Date(AddInvitadoAndCarnet.created);
      if (selectedDate <= createdDate) {
        errorMessage = "Debe ser mayor que la fecha de habilitación.";
        correctedValue = new Date(createdDate.getTime() + 60000).toISOString().slice(0, 16); // Ajuste de +1 minuto
      }
    }
    if (
      fieldName === "name" ||
      fieldName === "lastname" ||
      fieldName === "special_condition" ||
      fieldName === "origin_place"
    ) {
      // Permitir solo letras, tildes, ñ y espacios
      value = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g, "");
    }

    // Actualizar el estado con el valor corregido y los mensajes de error
    setAddInvitadoAndCarnet({
      ...AddInvitadoAndCarnet,
      [fieldName]: correctedValue,
    });

    setFieldErrors((prev) => ({
      ...prev,
      [fieldName]: errorMessage,
    }));

    setIsFieldValid((prev) => ({
      ...prev,
      [fieldName]: errorMessage === "",
    }));

    handleChangeValid(fieldName, correctedValue);
  };

  //ejecuta la funcion requestUpdateValidity con la información necesaria y cierra el modal de actualizar vigencia
  const handleSubmitEditValidity = async (e) => {
    e.preventDefault();
    setLoading(true);
    await requestUpdateValidityCard(editedDataValidity);
    handleCloseEditValidity();
    setLoading(false);
  };

  //abre el modal para cambiar la fecha de vigencia a un grupo de carnets
  const handleOpenValidity = (event) => {
    // event.preventDefault();

    if (selected.length === 0) {
      handleAlert("fail", "No se ha seleccionado ningún carnet");
      return;
    }
    setOpenValidity(true);
    setIsDisabled(false);
    //const { dataset } = event.currentTarget;
    const data = {
      expires_in: "",
      idArray: selected,
    };
    //setDefaultData(data);
    setEditedDataValidity(data);
  };

  // *********Se implementó en el filterController******
  // useEffect(() => {
  //   requestCarnets(currentPage, paginaSize);
  // }, [currentPage]);

  useEffect(() => {
    const currentUrl = window.location.href;
    const segments = currentUrl.split("/");
    const dataSourceId = segments[segments.length - 1];
    setDataSourceId(dataSourceId);
    setIsFilter(true);
  }, []);

  // Comprueba si algún campo ha cambiado desde los valores iniciales(vacio o nulo)
  useEffect(() => {
    const requiredFields = ["expires_in"];
    const someFieldIsEmpty = requiredFields.some((fieldName) => !editedDataValidity[fieldName]);
    setIsFormModified(someFieldIsEmpty);
  }, [editedDataValidity]);

  //Cambio de estado de carnets ------>
  const [openEditedStatus, setOpenEditedStatus] = useState(false);
  const [editStatusCarnet, setEditStatusCarnet] = useState({});
  const [idCarnet, setIdCarnet] = useState("");

  // cerrar modal de cambio de estado de carnets
  const handleCloseEditedStatus = () => setOpenEditedStatus(false);

  const requestEditStatusCarnet = async (id, statusCarnet) => {
    try {
      const result = await updatedStatusCarnet(id, statusCarnet);
      if (result.status !== false) {
        // const { data, last_page, total, from, to } = result;
        // await setListCarnets(data);
        //requestCarnetsPerFile(dataSourceId, currentPage);
        callHandleClickSubmit();
        handleCloseEditedStatus();
        handleAlert("success", "Estado actualizado correctamente");
        setError("");
      } else {
        handleAlert("fail", result.message || "Error al realizar la operación");
        setError("Error al consultar al servidor");
      }
    } catch (error) {
      handleAlert("fail", error.message || "Error al realizar la operación");
      setError("Error al consultar al servidor");
    }
  };

  const handleEditStatusCarnet = async (event) => {
    event.preventDefault();
    setLoading(true);
    const { dataset } = event.currentTarget;
    const statusEdited = dataset.status !== "Activo" ? "Activo" : "Inactivo";
    const data = {
      status: statusEdited,
    };
    setIdCarnet(dataset.idcarnet);
    setEditStatusCarnet(data);
    setOpenEditedStatus(true);
    setLoading(false);
  };

  const handleSubmitEditedStatusCarnet = async (e) => {
    e.preventDefault();
    setLoading(true);
    await requestEditStatusCarnet(idCarnet, editStatusCarnet);
    setLoading(false);
  };
  //<--------

  //Envia las ids de los carnets seleccionados
  const handleSendCarnetAccumulated = async (event) => {
    // event.preventDefault();
    setLoading(true);
    // setOpenValidity(true);
    // setIsDisabled(false);
    //const { dataset } = event.currentTarget;
    const data = {
      expires_in: "",
      idArray: selected,
    };

    const result = await sendCarnetAccumulated(data);

    if (result.status !== false) {
      //requestCarnetsPerFile(dataSourceId, currentPage);

      // Verificar si result.payload existe y es un string
      const message =
        typeof result.payload === "string" ? result.payload : "Carnets enviados correctamente";

      // Determinar el tipo de alerta basado en el contenido del mensaje
      if (message.includes("no pudieron ser enviados")) {
        // Si el mensaje indica que hubo carnets que no se enviaron, usar warning
        handleAlert("warning", message);
      } else {
        // Si todos los carnets se enviaron, usar success
        handleAlert("success", message);
      }

      callHandleClickSubmit();
    } else {
      handleAlert("fail", result.message || "Error al realizar la operación");
      // setError("Error al consultar al servidor");
    }
    setLoading(false);
  };
  //Función para obtener la fecha en formato local
  const getLocalDate = (dateString) => {
    const date = new Date(dateString);

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true, // Formato de 12 horas
    };

    return date.toLocaleString("es-CO", options); // "es-CO" es el código de lenguaje para Colombia
  };

  //mapeo de las filas que se listaran en la tabla de carnets
  const rows = listCarnets
    ? listCarnets.map((carnet) => {
        return {
          id: carnet.id,
          dni: carnet.number_id,
          email: carnet.email,
          name: `${carnet.card_user_name} ${carnet.card_user_lastname}`,
          card_type_name: carnet.card_type_name,
          card_type_id: carnet.card_type_id,
          created: getLocalDate(carnet.created),
          expired_in: getLocalDate(carnet.expires_in),
          joined:
            Number(carnet.joined) === 1 ? (
              <CheckCircleIcon
                style={{ fontSize: "200px", width: "24px", height: "24px", color: "green" }}
              />
            ) : (
              <CheckCircleIcon
                style={{ fontSize: "200px", width: "24px", height: "24px" }}
                color="disabled"
              />
            ),

          status:
            carnet.status === "Activo" ? (
              <MDBadge badgeContent="Activo" size="xs" container color="success" />
            ) : (
              <MDBadge badgeContent={carnet.status} size="xs" container color="error" />
            ),

          blood_type: carnet.blood_type,
          notified:
            carnet.notified == "1" ? (
              <AccessTimeOutlinedIcon
                style={{ fontSize: "200px", width: "24px", height: "24px" }}
                color="secondary"
                titleAccess="Enviado desde el sistema"
              ></AccessTimeOutlinedIcon>
            ) : (
              <MailOutlinedIcon
                style={{ fontSize: "200px", width: "24px", height: "24px" }}
                color="secondary"
                titleAccess="No notificado"
              ></MailOutlinedIcon>
            ),
          latest_link_status:
            carnet?.latest_link_status == "1" ? (
              <CheckCircleIcon
                style={{ fontSize: "200px", width: "24px", height: "24px", color: "green" }}
                titleAccess="Descargado"
              />
            ) : (
              <CheckCircleIcon
                style={{ fontSize: "200px", width: "24px", height: "24px" }}
                color="disabled"
                titleAccess="No descargado"
              />
            ),
          latest_link_created_at: carnet?.latest_link_created_at
            ? getLocalDate(carnet.latest_link_created_at)
            : "N/A",
          actions: (
            <>
              <a
                data-dni={carnet.number_id}
                data-name={carnet.card_user_name}
                data-lastname={carnet.card_user_lastname}
                data-status={carnet.status}
                data-created={carnet.created}
                data-expired={carnet.expires_in}
                data-type={carnet.card_type_name}
                data-datasource={carnet.data_source_name}
                data-userid={carnet.card_user_id}
                data-cardtypeid={carnet.card_type_id}
                data-bloodtype={carnet.blood_type}
                data-joined={carnet.joined}
                data-email={carnet.email}
                data-customdata={carnet.custom_data ? JSON.stringify(carnet.custom_data) : ""}
                data-specialcondition={carnet.special_condition}
                data-originplace={carnet.origin_place}
                style={{ cursor: "pointer" }}
                onClick={handleOpenToModal}
              >
                <FindInPageOutlinedIcon
                  titleAccess="Detalles"
                  style={{
                    fontSize: "200px",
                    width: "24px",
                    height: "24px",
                    backgroundImage: "#000000",
                  }}
                ></FindInPageOutlinedIcon>
                {/*<img src={verDetallesImg} />*/}
              </a>
              {carnet.status === "Inactivo" ? (
                <a
                  style={{
                    cursor: "pointer",
                    pointerEvents: "none",
                    cursor: "not-allowed",
                    textDecoration: "none",
                    color: "inherit",
                    marginLeft: "8px",
                    opacity: "0.5",
                  }}
                >
                  <DownloadIcon
                    titleAccess="Descargar Carnet"
                    style={{
                      fontSize: "200px",
                      width: "24px",
                      height: "24px",
                      backgroundImage: "#000000",
                    }}
                  />
                </a>
              ) : (
                <a
                  data-id={carnet.id}
                  onClick={handleDownloadCardById}
                  style={{
                    cursor: "pointer",
                    textDecoration: "none",
                    color: "inherit",
                    marginLeft: "8px",
                  }}
                >
                  <DownloadIcon
                    titleAccess="Descargar Carnet"
                    style={{
                      fontSize: "200px",
                      width: "24px",
                      height: "24px",
                      backgroundImage: "#000000",
                    }}
                  />
                </a>
              )}
              {carnet.status === "Activo" ? (
                <a
                  data-dni={carnet.number_id}
                  data-name={carnet.card_user_name}
                  data-lastname={carnet.card_user_lastname}
                  data-status={carnet.status}
                  data-created={carnet.created}
                  data-expired={carnet.expires_in}
                  data-type={carnet.card_type_name}
                  data-userid={carnet.card_user_id}
                  data-cardtypeid={carnet.card_type_id}
                  data-idcarnet={carnet.id}
                  style={{ cursor: "pointer", marginLeft: "8px" }}
                  onClick={handleEditStatusCarnet}
                >
                  <CreditCardOffOutlinedIcon
                    style={{
                      fontSize: "200px",
                      width: "24px",
                      height: "24px",
                      backgroundImage: "#000000",
                    }}
                    titleAccess="Desactivar carnet"
                  ></CreditCardOffOutlinedIcon>
                </a>
              ) : (
                <a
                  data-dni={carnet.number_id}
                  data-name={carnet.card_user_name}
                  data-lastname={carnet.card_user_lastname}
                  data-status={carnet.status}
                  data-created={carnet.created}
                  data-expired={carnet.expires_in}
                  data-type={carnet.card_type_name}
                  data-cardtypeid={carnet.card_type_id}
                  data-idcarnet={carnet.id}
                  style={{ cursor: "pointer", marginLeft: "8px" }}
                  onClick={handleEditStatusCarnet}
                >
                  <CreditCardOutlinedIcon
                    style={{
                      fontSize: "200px",
                      width: "24px",
                      height: "24px",
                      backgroundImage: "#000000",
                    }}
                    titleAccess="Activar carnet"
                  ></CreditCardOutlinedIcon>
                </a>
              )}
            </>
          ),
        };
      })
    : [];

  //Guarda o borra la id de la fila seleccionada o desceleccionada en el array selected
  const handleSelect = (id) => {
    if (isCardExpired(id)) return; // No hacer nada si el carnet está expirado

    const newSelected = [...selected];
    const selectedIndex = selected.indexOf(id);

    if (selectedIndex === -1) {
      newSelected.push(id);
    } else {
      newSelected.splice(selectedIndex, 1);
    }
    setSelected(newSelected);
  };

  //Selecciona todas las filas de una pagina y las guarda o borra(si es desceleccionada) en el array selected
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const selectableRowIds = getSelectableRows().map((row) => row.id);
      setSelected(selectableRowIds);
    } else {
      setSelected([]);
    }
  };

  // Función para verificar si un carnet está expirado
  const isCardExpired = (rowId) => {
    const row = rows.find((r) => r.id === rowId);
    if (!row) return true;

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const expiryDate = new Date(row.expired_in);
    // return expiryDate < today || row.status?.props?.badgeContent === "Inactivo";
    return row.status?.props?.badgeContent === "Inactivo";
  };

  // Función para obtener solo las filas seleccionables (no expiradas)
  const getSelectableRows = () => {
    return rows.filter((row) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const expiryDate = new Date(row.expired_in);
      // return expiryDate >= today && row.status?.props?.badgeContent !== "Inactivo";
      return row.status?.props?.badgeContent !== "Inactivo";
    });
  };

  // Función para llamar a handleClickSubmit desde el componente padre
  const callHandleClickSubmit = () => {
    if (filterControllerRef.current) {
      filterControllerRef.current.handleClickSubmit();
    }
  };

  // Maneja las alertas de exito fallo
  const handleAlert = (typeAlert, message) => {
    setTypeAlert(typeAlert);
    setMessage(message);
    setIsAlert(true);
  };

  // Estado de las validaciones
  const [isFieldValid, setIsFieldValid] = useState({
    name: true,
    lastname: true,
    email: true,
    role_id: true,
    status: true,
    number_id: true,
    blood_type: true,
    created: true,
    expires_in: true,
    card_type_id: true,
    special_condition: true,
    origin_place: true,
  });

  // Setea los valores de las validaciones
  const resetFieldValid = () => {
    setIsFieldValid({
      name: true,
      lastname: true,
      email: true,
      role_id: true,
      status: true,
      number_id: true,
      blood_type: true,
      created: true,
      expires_in: true,
      status: true,
      card_type_id: true,
      special_condition: true,
      origin_place: true,
    });
  };

  // Expresiones regulares para diferentes tipos de campos
  const validationPatterns = {
    name: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/, // Permite letras, tildes, ñ y espacios
    lastname: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/, // Permite letras, tildes, ñ y espacios
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, // Verifica el formato de correo electrónico
    role_id: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
    status: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
    number_id: /^[0-9]+$/, // Solo permite números
    blood_type: /^(A|B|AB|O)[+-]$/, // Tipos de sangre válidos
    created: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/, // Permite los segundos (opcionalmente)
    expires_in: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/, // Permite los segundos (opcionalmente)
    status: /^[a-zA-Z\s]*$/, // Solo permite letras y espacios
    card_type_id: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
    special_condition: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/, // Permite letras, tildes, ñ y espacios
    origin_place: /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]*$/, // Permite letras, tildes, ñ y espacios
  };

  // Compara el valor del input con la expresion regular requeridahandleChangeValid
  const validateField = (value, pattern) => {
    return pattern.test(value);
  };

  // Comprueba la validez del campo y luego establece la validez en el estado
  const handleChangeValid = (fieldName, value) => {
    const isFieldValid = validateField(value, validationPatterns[fieldName]);

    setIsFieldValid((prevValidity) => ({
      ...prevValidity,
      [fieldName]: isFieldValid,
    }));
  };

  useEffect(() => {
    const currentUrl = window.location.href;
    const extractedDataSourceId = currentUrl.split("/Fuentes/")[1];
    console.log("dataSourceId:", extractedDataSourceId);
    setDataSourceId(extractedDataSourceId);

    if (extractedDataSourceId) {
      requestDataSource(extractedDataSourceId);
    }
  }, []);

  const requestDataSource = async (id) => {
    try {
      const result = await getDataSourceId(id);
      console.log("Respuesta de getDataSourceId:", result);

      if (result && result.status !== false) {
        const { payload } = result;
        if (payload && payload.card_type_name) {
          setDataSource({
            name: payload.source_name,
            type: payload.source_type_name,
            card_type_name: payload.card_type_name,
          });
        } else {
          console.error("La respuesta no contiene card_type_name:", payload);
          setError("Error: La respuesta del servidor no contiene card_type_name");
        }
      } else {
        setError("Error al consultar al servidor");
      }
    } catch (error) {
      console.error("Error en requestDataSource:", error);
      setError("Error al consultar al servidor");
    }
  };

  const submitCarnetAndUserCreate = async (e) => {
    e.preventDefault();
    setLoading(true);

    const convertedObject = convertValuesToString(AddInvitadoAndCarnet);

    // Añade dataSourceId a convertedObject
    const extendedObject = {
      ...convertedObject,
      data_source_id: dataSourceId,
      userId: localStorage.getItem("user_id"),
    };

    const result = await CardAndUserCreateService(extendedObject);

    if (result.status !== false) {
      if (result.message) {
        handleAlert("success", result.message);
      } else {
        handleAlert("success", "Registro creado correctamente");
      }
      callHandleClickSubmit();
      handleCloseAddInvitadoAndCarnet();
    } else {
      if (result.errors) {
        handleAlert("fail", result.errors.join("\n"));
      } else {
        handleAlert("fail", result.message || "Error desconocido");
      }
    }

    setLoading(false);
  };

  const closeRoleCreate = () => setOpenModalAddInvitadoAndCarnet(false);

  //Abrir modal de agregar invitado
  //const handleOpenModalAddInvitadoAndCarnet = () => setOpenModalAddInvitadoAndCarnet(true);
  const requestCarnetTypes = async (pageIndex) => {
    const result = await getCardTypes(pageIndex);

    if (result.status !== false) {
      const { data, last_page, total, from, to } = result;
      await setCarnetTypes(data);
    } else {
      //setErrorAlert("Error al consultar al servidor");
    }
  };
  //Abrir modal de agregar invitado
  const handleOpenModalAddInvitadoAndCarnet = async (event) => {
    event.preventDefault();

    setIsDisabled(false);
    const data = {
      status: "",
      created: "",
      expires_in: "",
      name: "",
      lastname: "",
      number_id: "",
      email: "",
      blood_type: "",
      card_type_id: dataSource.card_type_name,
      card_user_id: userId,
      card_user_name: "",
      card_user_lastname: "",
      data_source_id: dataSourceId,
      special_condition: "",
      origin_place: "",
    };

    setDefaultData(data);
    setAddInvitadoAndCarnet(data);
    await requestCarnetTypes(1);
    // AddInvitadoAndCarnet(data);
    setOpenModalAddInvitadoAndCarnet(true);
  };

  const [bloodTypes, setBloodTypes] = useState([
    "N/A",
    "A+",
    "A-",
    "B+",
    "B-",
    "AB+",
    "AB-",
    "O+",
    "O-",
  ]);

  useEffect(() => {
    const requiredFields = [
      "name",
      "lastname",
      "number_id",
      "email",
      "created",
      "expires_in",
      "status",
    ];
    const someFieldIsEmpty = requiredFields.some((fieldName) => !AddInvitadoAndCarnet[fieldName]);
    if (dataSource.card_type_name === "Invitado") {
      setBloodTypes(["N/A", "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"]);
    } else {
      setBloodTypes(["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"]);
    }
    setIsFormModified(someFieldIsEmpty);
  }, [AddInvitadoAndCarnet]);

  //<---------

  return (
    <>
      <Spinner loading={loading}></Spinner>
      {usePermission("Card.byFilterPerFile") && (
        <>
          {isFilter && (
            <FilterController
              data={listCarnets}
              dataFilter={dataFilter}
              dataTable={dataTable}
              setListData={setListCarnets}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              setTotalPages={setTotalPages}
              requestData={requestCarnetsPerFile}
              setError={setError}
              setTotalData={setTotalData}
              setEntriesEnd={setEntriesEnd}
              setEntriesStart={setEntriesStart}
              dataSourceId={dataSourceId}
              setLoading={setLoading}
              ref={filterControllerRef}
            ></FilterController>
          )}
        </>
      )}
      <MDAlert
        isAlert={isAlert}
        setIsAlert={setIsAlert}
        typeAlert={typeAlert}
        message={message}
      ></MDAlert>
      <ListCarnets
        listCarnets={listCarnets}
        handleSendCard={handleSendCard}
        limitResult={limitResult}
        error={error}
        pageIndexAndPageSize={pageIndexAndPageSize}
        entriesStart={entriesStart}
        entriesEnd={entriesEnd}
        totalData={totalData}
        paginaSize={paginaSize}
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
        handleOpenToModal={handleOpenToModal}
        selected={selected}
        handleSelect={handleSelect}
        handleSelectAll={handleSelectAll}
        getSelectableRows={getSelectableRows}
        handleOpenValidity={handleOpenValidity}
        handleSendCarnetAccumulated={handleSendCarnetAccumulated}
        handleOpenModalAddInvitadoAndCarnet={handleOpenModalAddInvitadoAndCarnet}
        rows={rows}
      ></ListCarnets>
      <ViewUserPerCard
        isOpenModal={isOpenModal}
        handleCloseToModal={handleCloseToModal}
        isDisabled={isDisabled}
        typeCarnets={typeCarnets}
        getFieldValue={getFieldValue}
      ></ViewUserPerCard>
      <ValidityCarnet
        open={openValidity}
        handleClose={handleCloseEditValidity}
        isFormModified={isFormModified}
        isDisabled={isDisabled}
        getFieldValue={getFieldValueEditValidity}
        handleFieldChange={handleFieldChangeEditValidity}
        handleSubmit={handleSubmitEditValidity}
        selected={selected}
      ></ValidityCarnet>
      <CarnetEditedStatus
        openEditedStatus={openEditedStatus}
        handleCloseEditedStatus={handleCloseEditedStatus}
        infoStatus={editStatusCarnet}
        handleSubmitDelete={handleSubmitEditedStatusCarnet}
      ></CarnetEditedStatus>
      <ModalAddInvitadoAndCarnet
        open={openModalAddInvitadoAndCarnet}
        dataSource={dataSource}
        handleClose={handleCloseAddInvitadoAndCarnet}
        isFormModified={isFormModified}
        isDisabled={isDisabled}
        getFieldValue={getFieldValueAddInvitadoAndCarnet}
        handleFieldChange={handleFieldChangeAddInvitadoAndCarnet}
        handleSubmit={submitCarnetAndUserCreate}
        isFieldValid={isFieldValid}
        bloodTypes={bloodTypes}
        carnetTypes={carnetTypes}
        data_Source_Id={dataSourceId}
        fieldErrors={fieldErrors}
      />
    </>
  );
}
